import Axios from 'axios'
let axios = Axios.create()
let axiosRaw = Axios.create()

axios.interceptors.response.use((response) => {
    // Si existe un problema de red, terminar la promesa
    if (response instanceof Error) {
        return Promise.reject(response.message)
    } else {
        return Promise.resolve(response.data)
    }
})
axiosRaw.interceptors.response.use((response) => {
    // Si existe un problema de red, terminar la promesa
    if (response instanceof Error) {
        return Promise.reject(response)
    } else {
        return Promise.resolve(response)
    }
})

export default {
    cliente: (idCliente) => ({
        getLocales: () =>
            axios.get(`/api/cliente/${idCliente}/locales`),
        getCorreos: () =>
            axios.get(`/api/local/${idCliente}/correo-nomina`),
        agregarCorreo: (datos) =>
            axios.post(`/api/local/${idCliente}/correo-nomina`, datos),
        quitarCorreo: (idCorreo) =>
            axios.delete(`/api/local/${idCliente}/correo-nomina/${idCorreo}`),
    }),
    local: {
        nuevo: (datos) =>
            axios.post(`/api/local`, datos),
        nuevos: (locales) =>
            axios.post(`/api/locales`, { locales }),
        actualizar: (idLocal, datos) =>
            axios.put(`/api/local/${idLocal}`, datos),
        enviarPegarStock: (idCliente, datos) =>
            axios.post('/api/stock/pegar', { idCliente, datos }),
        geolocalizacion: (idLocal, lat, long) =>
            axios.post('/api/local/geolocalizacion', {idLocal: idLocal, lat: lat, long: long})
    },
    inventario: {
        estadosInventarios : () => 
            axios.get('/api/inventarios/estados'),
        updateEstado : (idInventario, idEstado) => 
            axios.post('/api/inventario/update-estado', { idInventario, idEstado }),
        nuevo: (datos) =>
            axios.post(`/api/inventario/nuevo`, datos),
        // boton para publicar ig semanal (modal)
        publicarProgramacion: (fechaInicio, fechaFin, estatus) =>
            axios.post(`/api/inventarios/publicar-programacion`, { fechaInicio, fechaFin, estatus }),
        actualizar: (idInventario, datos) =>
            axios.put(`/api/inventario/${idInventario}`, datos),
        actualizarIgMensual: (idInventario, datos) =>
            axios.put(`/api/inventario/mensual/${idInventario}`, datos),
        updateStatus: (idService, idStatus) =>
            axios.put(`/api/inventario/${idService}/${idStatus}/cambiar-status`),
        updateDepartureTime: (idService, departureTime) =>
            axios.put(`/api/inventario/${idService}/departure-time`, { departureTime }),
        eliminar: (idInventario) =>
            axios.delete(`/api/inventario/${idInventario}`),
        // mes y cliente se usa en IG Mensual
        getPorMesYCliente: (annoMesDia, idCliente) =>
            axios.get(`/api/inventarios/buscar-2-mensual?mes=${annoMesDia}&idCliente=${idCliente}&incluirConFechaPendiente=true`),
        buscar2: (fechaInicio, fechaFin, idCliente) =>
            axios.get(`/api/inventarios/buscar-2?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&idCliente=${idCliente}`),
        // utilizado en buscar de mantenedor inventarios publicados
        buscarResumido: (fechaInicio, fechaFin, idCliente) =>
            axios.get(`/api/inventarios/buscar-publicados?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&idCliente=${idCliente}`),
        // utilizado en modal para publicar ig semanal
        buscarPorPublicar: (fechaInicio, fechaFin, idCliente) =>
            axios.get(`/api/inventarios/buscar-por-publicar?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&idCliente=${idCliente}`),
        getInventariosDif: (mes) =>
            axios.get(`/api/inventarios/buscarInv/${mes}`),
        getDetalle: (fechaInicio, fechaFin, cliente, region) =>
            axios.get(`/api/inventarios/detalle?cliente=${cliente}&region=${region}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getAprobadosMesCliente: (mes, idCliente) =>
            axios.get(`/api/inventarios/aprobados/${mes}/${idCliente}`),
        getRealizadosMesCliente: (mes, idCliente) =>
            axios.get(`/api/inventarios/realizados/${mes}/${idCliente}`),
        getAprobadosSEIMesCliente: (mes, idCliente) =>
            axios.get(`/api/inventarios/aprobados/sei/${mes}/${idCliente}`),
        publicarInventarios: (inventarios) =>
            axios.post(`/api/inventarios/publicar`, { inventarios }),
        obtenerDetalles: () =>
            axios.get(`/api/inventarios/detalles-total`),
        acta: {
            get: idInventario =>
                axios.get(`/api/inventario/${idInventario}/acta-fcv`),
            actualizar: (idInventario, datos) =>
                axios.post(`/api/inventario/${idInventario}/acta-fcv`, datos),
            publicar: (idInventario) =>
                axios.post(`/api/inventario/${idInventario}/publicar-acta-fcv`),
            despublicar: (idInventario) =>
                axios.post(`/api/inventario/${idInventario}/despublicar-acta-fcv`),
            reprocesar: (idArchivo) =>
                axios.post(`/api/inventario/archivo-final/${idArchivo}/reprocesar-fcv`),
        }
    },
    auditoria: {
        nuevo: (datos) =>
            axios.post(`/api/auditoria/nuevo`, datos),
        nuevaCapturaVencimiento: (nuevaCaptura) =>
            axios.post(`/api/captura/vencimiento/nueva`, nuevaCaptura),
        actualizar: (idAuditoria, datos) =>
            axios.put(`/api/auditoria/${idAuditoria}`, datos),
        actualizarAprobacion: (idAuditoria, aprobacionCliente) =>
            axios.post(`/api/auditoria/aprobacion/${idAuditoria}`, { aprobacionCliente }),
        eliminar: (idAuditoria) =>
            axios.delete(`/api/auditoria/${idAuditoria}`),
        getPorMesYCliente: (annoMesDia, idCliente) =>
            axios.get(`/api/auditoria/buscar?idCliente=${idCliente}&mes=${annoMesDia}&incluirConFechaPendiente=true&auditoriaSensores=false`),
        getPorRangoYCliente: (fechaInicio, fechaFin, idCliente) =>
            axios.get(`/api/auditoria/buscar?idCliente=${idCliente}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&ordenarAuditoriaSensores=true`),
        getResumenMes: (mes) =>
            axios.get(`/api/auditoria/resumen/${mes}`),
        getResumenEstadoMesActual: () =>
            axios.get(`/api/auditorias/estado-general-fcv`),
        getDetalle: (fechaInicio, fechaFin, cliente, region) =>
            axios.get(`/api/auditorias/detalle?cliente=${cliente}&region=${region}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getRutaInicioAuditores: (fechaInicial) =>
            axios.get(`/api/auditorias/reporte-ruta?fechaInicio=${fechaInicial}`)
    },
    nominas: {
        usuariosPendientes: (fechaInicio, fechaFin) =>
            axios.get(`/api/nominas/userPendientes?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getEstado: (idUsuario, idCliente) =>
            axios.get(`/api/personal/bloqueo-cliente?idOperador=${idUsuario}&idCliente=${idCliente}`),
        getPorRangoYSolicitud: (fechaInicio, fechaFin) =>
            axios.get(`/api/nominas/solicitudes?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getSolicitudesCambio: (fechaInicio, fechaFin) =>
            axios.get(`/api/nominas/solicitud/cambio-nomina?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getCambiosNominas: (fechaInicio, fechaFin) =>
            axios.get(`/api/nominas/rectificada/cambio?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        enviarNominasMasiva: (data, conCorreo) =>
            axios.post("/api/nominas/envioNominasMasiva", { 'nominas': data, conCorreo }),
        aprobarNominasMasiva: (data) =>
            axios.post("/api/nominas/aprobarNominasMasiva", { 'nominas': data }),
        rectificarNominasMasiva: (data) =>
            axios.post("/api/nominas/rectificarNominasMasiva", { 'nominas': data }),
        asignacionMasivaLider: (data, cambiosNominas) =>
            axios.post("/api/nominas/asignacionMasivaLider", { 'nominas': data, cambiosNominas })
    },
    nomina: (idNomina) => ({
        // utilizada por programacion IG para actualizar lider
        actualizar: (datos) =>
            axios.put(`/api/nomina/${idNomina}`, datos),
        actualizarEmailContacto: (emailContacto) =>
            axios.post(`/api/nomina/${idNomina}/actualizar-email`, { emailContacto }),
        agregarLider: (usuarioRUN) =>
            axios.post(`/api/nomina/${idNomina}/lider/${usuarioRUN}`),
        quitarLider: () =>
            axios.delete(`/api/nomina/${idNomina}/lider`),
        agregarCaptador: (idUsuario) =>
            axios.post(`/api/nomina/${idNomina}/captador/${idUsuario}`),
        quitarCaptador: (idUsuario) =>
            axios.delete(`/api/nomina/${idNomina}/captador/${idUsuario}`),
        agregarRegionesCaptador: (idCaptador, regiones) =>
            axios.post(`/api/nomina/${idNomina}/captador-regiones/${idCaptador}`, regiones),
        cambiarAsignadosCaptador: (idCaptador, payload) =>
            axios.put(`/api/nomina/${idNomina}/captador/${idCaptador}`, payload),
        agregarSupervisor: (usuarioRUN) =>
            axios.post(`/api/nomina/${idNomina}/supervisor/${usuarioRUN}`),
        quitarSupervisor: () =>
            axios.delete(`/api/nomina/${idNomina}/supervisor`),
        agregarOperador: (usuarioRUN, esTitular, idCaptador) =>
            axiosRaw.post(`/api/nomina/${idNomina}/operador/${usuarioRUN}`, { esTitular, idCaptador }),
        addAlternateLeader: (userRUN) =>
            axiosRaw.post(`/api/nomina/${idNomina}/alternate-leader/${userRUN}`),
        quitarOperador: (usuarioRUN, esTitular) =>
            axios.delete(`/api/nomina/${idNomina}/operador/${usuarioRUN}/${esTitular}`),
        cambiarDePanel: (usuarioRUN, esTitular, idCaptador, pendientes) =>
            axios.post(`/api/nomina/${idNomina}/operador/${usuarioRUN}/panel`, { esTitular, idCaptador, pendientes }),
        lideresDisponibles: () =>
            axios.get(`/api/nomina/${idNomina}/lideres-disponibles`),
        getAlternateLeaders: () =>
            axios.get(`/api/nomina/${idNomina}/alternate-leaders`),
        enviar: () =>
            axios.post(`/api/nomina/${idNomina}/estado-enviar`),
        aprobar: () =>
            axios.post(`/api/nomina/${idNomina}/estado-aprobar`),
        rechazar: () =>
            axios.post(`/api/nomina/${idNomina}/estado-rechazar`),
        informar: () =>
            axios.post(`/api/nomina/${idNomina}/estado-informar`),
        completarSinCorreo: () =>
            axios.post(`/api/nomina/${idNomina}/estado-informar`, { omitirCorreo: true }),
        disponibilidadReemplazos: () =>
            axios.get(`/api/nomina/${idNomina}/disponibilidad-reemplazos`),
        informarDisponibilidadReemplazos: (cupos) =>
            axios.post(`/api/nomina/${idNomina}/informar-disponibilidad-reemplazos`, { cupos: cupos }),
        rectificar: () =>
            axios.post(`/api/nomina/${idNomina}/estado-rectificar`),
        historial: () =>
            axios.get(`/api/nomina/${idNomina}/historial`),
        estadoSolicitud: (estadoSolicitud) =>
            axios.post(`/api/nomina/${idNomina}/estado-solicitud`, { estadoSolicitud }),
        cambioEstadoSolicitud: (operadorActual, operadorNuevo, estado) =>
            axios.post(`/api/nominas/solicitud/cambio/estado`, { operadorActual, operadorNuevo, idNomina, estado }),
        getOperadoresDisponibles: () =>
            axios.get(`/api/nomina/${idNomina}/operadores/disponibles`),
        cambioNominaInformada: (estado) =>
            axios.post(`/api/nomina/${idNomina}/cambio/operadores/informados`, { estado }),
        quitarOperadoresMasivo: (data) =>
            axios.post(`/api/nomina/${idNomina}/quitar-operador-masivo`, { operadores: data }),
        operadorTitularMasivo: (data) =>
            axios.post(`/api/nomina/${idNomina}/operador-titular-masivo`, { operadores: data }),
        bloqueoLog: (idOperador) =>
            axios.post(`/api/nomina/${idNomina}/operador/${idOperador}/bloqueo-log`),
        enrocarOperadores: (titulares, reemplazos) =>
            axios.post(`/api/nomina/${idNomina}/enrocar-operadores`, { titulares, reemplazos }),
        operadorEscondido: (id) =>
            axios.post(`/api/nomina/${idNomina}/operador-escondido`, { id: id }),
        actualizarEstadisticas: (titulares, reemplazos) =>
            axios.post(`/api/nomina/${idNomina}/estadisticas-enroque`, { titulares, reemplazos }),
        changeTurnoEmergencia: (status) =>
            axios.post(`/api/nomina/${idNomina}/turno-emergencia`, { status: status }),
        changeTurnoAvanzada: (status) =>
            axios.post(`/api/nomina/${idNomina}/turno-avanzada`, { status: status }),
        changeTurnoAvanzadaOpSolicitud: (data) =>
            axios.post(`/api/nomina/${idNomina}/operador/turno-avanzada-solicitud`, data),
        changeTurnoAvanzadaOp: (data) =>
            axios.post(`/api/nomina/${idNomina}/operador/turno-avanzada`, data),
        changeTurnoAvanzadaOpHrs: (data) =>
            axios.post(`/api/nomina/${idNomina}/operador/turno-avanzada-hrs`, data),
        verPasajesLider: () =>
            axios.get(`/api/nomina/${idNomina}/obtener-data-pasajes`),
        subirPasajesLider: (data) =>
            axios.post(`/api/nomina/${idNomina}/subir-pasajes-lider`, data),
        editarPasaje: (data) =>
            axios.post(`/api/nomina/${idNomina}/editar-pasaje`, data),
        eliminarPasaje: (id) =>
            axios.post(`/api/nomina/${idNomina}/eliminar-pasaje`, { id: id }),
        quitarEscondido: (id) =>
            axios.post(`/api/nomina/${idNomina}/quitar-escondido`, { id: id }),
        operadoresPendientesRegion: () =>
            axios.get(`/api/nomina/${idNomina}/operadores/pendientes-region`),
        operadorComoReemplazo: (idUser, idCaptador) =>
            axios.post(`/api/nomina/${idNomina}/operadores/pasar-a-reemplazo`, { idUser: idUser, idCaptador: idCaptador }),
        cambiarCaptador: (idUser, idCaptador) =>
            axios.post(`/api/nomina/${idNomina}/operadores/cambiar-captador-log`, { idUser: idUser, idCaptador: idCaptador }),
        agregarGPS: (id, lat, lng) =>
            axios.post(`/api/nomina/${idNomina}/agregar-gps`, { id: id, lat: lat, lng: lng }),
        masTiempoConfirmacion: (id, confirma) =>
            axios.post(`/api/nomina/${idNomina}/confirmacion-mas-tiempo`, { id: id, confirma: confirma }),

    }),
    nominaLideresDisponibles: (idNominaNoche, idNominaDia) => ({
        lideresDisponibles: () =>
            axios.get(`/api/nomina/${idNominaNoche}/${idNominaDia}/lideres-disponibles`),
        auditoresSMUDisponibles: () =>
            axios.get(`/api/nomina/${idNominaNoche}/${idNominaDia}/auditoresSMU-disponibles`)

    }),
    geo: {
        comunas: () =>
            axios.get(`/api/geo/comunas`)
    },
    usuarios: {
        fetch: (idDocumentationState) =>
            axios.get(`/api/usuarios/buscar?idDocumentationState=${idDocumentationState}`)
        ,
        fetchPendientes: () =>
            axios.get(`/api/usuarios/buscar-pendientes`),
        nuevoUsuario: (datos) =>
            axios.post(`/api/usuarios/nuevo-usuario`, datos),
        nuevoOperador: (datos) =>
            axios.post(`/api/usuarios/nuevo-operador`, datos),
        registrarOperador: (datos) =>
            axios.post(`/api/usuarios/registrar-operador`, datos),
        confirmarOperador: (datos) =>
            axios.post(`/api/usuarios/buscar-pendientes/nuevo`, datos),
        rechazarOperador: (datos) =>
            axios.post(`/api/usuarios/buscar-pendientes/cancel`, datos)
    },
    usuario: (idUsuario) => ({
        get: () =>
            axios.get(`/api/usuario/${idUsuario}`),
        actualizar: (datos) =>
            axios.put(`/api/usuario/${idUsuario}`, datos),
        bloquear: () =>
            axios.post(`/api/usuario/${idUsuario}/bloquear`),
        desbloquear: () =>
            axios.post(`/api/usuario/${idUsuario}/desbloquear`, {}),
        suspend: (idReason) =>
            axios.post(`/api/usuario/${idUsuario}/${idReason}/suspend`),
        cambiarContrasena: (contrasena) =>
            axios.post(`/api/usuario/${idUsuario}/cambiar-contrasena`, { contrasena }),
        historial: () =>
            axios.get(`/api/usuario/${idUsuario}/historial-nominas`),
        bloquearCliente: (datos) =>
            axios.put(`/api/personal/${idUsuario}/bloqueo-cliente`, datos),
        uploadPersonalFile: (data) =>
            axios.post(`/api/usuario/${idUsuario}/upload/personal-files`, data),
        uploadOperadorFile: (data) =>
            axios.post(`/api/usuario/${idUsuario}/upload/operator-files`, data),
        uploadFechaVenc: (data) =>
            axios.post(`/api/usuario/${idUsuario}/upload/fecha-venc-dni`, data),
        getDocumentation: () =>
            axios.get(`/api/usuario/${idUsuario}/documentacion`),
        changeStatusDocumentation: (status) =>
            axios.post(`/api/usuario/${idUsuario}/status-documentation`, { status }),
        bloquearTitular: (idNomina) =>
            axios.post(`/api/usuario/${idUsuario}/bloquear-titular/${idNomina}`),
    }),
    documentUser: (idFile) => ({
        isWrongFile: (status) =>
            axios.post(`/api/document-user/${idFile}/wrong`, { status }),
        deleteFile: () =>
            axios.post(`/api/document-user/${idFile}/delete`),
    }),
    vistaGeneral: {
        fetch: (annoMesDia, idCliente = 0) =>
            axios.get(`/api/vista-general/nominas-inventarios?idCliente=${idCliente}&annoMesDia=${annoMesDia}`),
    },
    otros: {
        bancos: () =>
            axios.get(`/api/bancos`),
        comunas: () =>
            axios.get(`/api/comunas`),
        regiones: () =>
            axios.get(`/api/regiones`),
        zonas: () =>
            axios.get(`/api/zonas`),
        comunasZonas: (zonas) =>
            axios.post(`/api/zonas/comunas`, { zonas })
    },
    captador: (idCaptador) => ({
        getZonas: () =>
            axios.get(`/api/captador/${idCaptador}/zonas`),
        getFaltas: () =>
            axios.get(`/api/captador/${idCaptador}/faltas`),
        actualizarValor: (zona, valor) =>
            axios.post(`/api/captador/${idCaptador}/valor`, { zona, valor }),
        asociarZona: (zona, valor) =>
            axios.post(`/api/captador/${idCaptador}/zona`, { zona, valor }),
    }),
    produccion: (idCliente, idJornada) => ({
        getProducciones: () =>
            axios.get(`/api/producciones/${idCliente}/${idJornada}`),
        actualizarProduccion: (idProduccion, valor) =>
            axios.post(`/api/produccion/${idProduccion}/valor`, { valor })
    }),
    inv: (idInventario) => ({
        actualizarStockFCV: (stockFCV) =>
            axios.post(`/api/inventario/${idInventario}/stockFCV`, { stockFCV }),
        actualizarAprobacionFCV: (estado) =>
            axios.post(`/api/inventario/${idInventario}/aprobacion`, { estado }),
        actualizarAprobacionSei: (estadoSei) =>
            axios.post(`/api/inventario/${idInventario}/aprobacionSei`, { estadoSei }),
        actualizarObservacion: (observacionCliente) =>
            axios.post(`/api/inventario/${idInventario}/observacionCliente`, { observacionCliente }),
    }),
    facturacionSaldo: () => ({
        getDetalleSaldo: (mes) =>
            axios.get(`/api/facturacion/saldo/${mes}`),
        generarSaldo: (mes) =>
            axios.post(`/api/generar/saldo`, { mes }),
        generarSaldoAuditorias: (mes) =>
            axios.post(`/api/generar/saldo/auditorias`, { mes })
    }),
    facturacion: (idCliente) => ({
        generarCorreoSei: (mes) =>
            axios.post(`/api/generar/correoSEI/${idCliente}`, { mes }),
        generarCorreoAud: (mes) =>
            axios.post(`/api/generar/correoSEI/auditorias/${idCliente}`, { mes }),
        generarCorreoIG: (mes, total) =>
            axios.post(`/api/generar/correoSEI/ig/aprobacion/${idCliente}`, { mes, total }),
        generarFactura: (mes) =>
            axios.post(`/api/generar/factura/${idCliente}`, { mes }),
        agregarOrdenCompra: (fechaInicial, fechaFinal, numeroOC) =>
            axios.post(`/api/agregar/orden-compra/${idCliente}`, { fechaInicial, fechaFinal, numeroOC }),
        serviciosRealizados: (mes) =>
            axios.get(`/api/servicios-realizados/${idCliente}/${mes}`),
        getServiciosSalcobrand: (mes) =>
            axios.get(`/api/servicios/salcobrand/${idCliente}/${mes}`),
        generarFacturaAF: (mes, numeroHES, fechaEmisionHES) =>
            axios.post(`/api/generar/factura/af/${idCliente}`, { mes, numeroHES, fechaEmisionHES }),
        disponiblesCliente: (fechaInicio, fechaFin) =>
            axios.get(`/api/facturacion/lista/${idCliente}/${fechaInicio}/${fechaFin}`),
        serviciosCalidad: (mes) =>
            axios.get(`/api/servicios-calidad/${idCliente}/${mes}`),
        getCalidadAprobados: (mes) =>
            axios.get(`/api/servicios-calidad/aprobados/${idCliente}/${mes}`)
    }),
    aud: () => ({
        actualizarAprobacionFCV: (aprobacionCliente, mes) =>
            axios.post(`/api/auditoria/aprobacion`, { aprobacionCliente, mes }),
    }),
    auditorias: () => ({
        getArchivosConsolidados: (mes, tipo) =>
            axios.get(`/api/auditorias/archivosConsolidados/${mes}/${tipo}`)
    }),
    api: () => ({
        misInventariosDia: (idInventario) =>
            axios.post(`/api/misInventarios/dia`, { idInventario }),
        misReportesInventario: (idInventario) =>
            axios.post(`/api/misReportes/inventario`, { idInventario }),
        misReportesNuevo: (idInventario, tipo, hora, dotacion, avance, error, comentario, auditoria, idDescripcionReportesIG, idDescripcionReportesLocal) =>
            axios.post(`/api/misReportes/nuevo`, { idInventario, tipo, hora, dotacion, avance, error, comentario, auditoria, idDescripcionReportesIG, idDescripcionReportesLocal }),
        descripcionReportes: (tipoDescripcion, subTipoDescripcion) =>
            axios.post(`/api/descripcion/reportes`, { tipoDescripcion, subTipoDescripcion }),
        nuevoAnexoMarca: (idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance) =>
            axios.post(`/api/nuevo/anexoMarca`, { idMarca, estado_deterioro, sku_deterioro, estado_pago, foto_avance })
    }),
    capturasAuditoria: (idAuditoria) => ({
        getAuditoria: () =>
            axios.get(`/api/auditoria/${idAuditoria}/revision`),
        actualizarDatosAuditoria: (auditoria) =>
            axios.post(`/api/auditoria/${idAuditoria}/datos`, auditoria),
        actualizarIRD: (idCapturaAuditoriaIrd, capturaIRD) =>
            axios.post(`/api/captura/${idCapturaAuditoriaIrd}/captura-ird`, capturaIRD),
        actualizarVencimiento: (idCapturaAuditoriaVencimiento, capturaVencimiento) =>
            axios.post(`/api/captura/${idCapturaAuditoriaVencimiento}/captura-vencimiento`, capturaVencimiento),
        buscarImagenRemplazo: (idCapturaAuditoriaVencimiento, sku, lote, fecha_exp) =>
            axios.get(`/api/captura/${idCapturaAuditoriaVencimiento}/sku/${sku}/lote/${lote}/fecha/${fecha_exp}`),
        postRemplazoImagen: (idCapturaVencimientoOriginal, idArchivoImagen) =>
            axios.post(`/api/captura/imagen/remplazo`, { idCapturaVencimientoOriginal, idArchivoImagen }),
        eliminarCapturaIRD: (idCapturaAuditoriaIrd) =>
            axios.post(`/api/captura/${idCapturaAuditoriaIrd}/captura-ird/eliminar`),
        restaurarCapturaIRD: (idCapturaAuditoriaIrd) =>
            axios.post(`/api/captura/${idCapturaAuditoriaIrd}/captura-ird/restaurar`),
        eliminarCapturaVencimiento: (idCapturaAuditoriaVencimiento) =>
            axios.post(`/api/captura/${idAuditoria}/${idCapturaAuditoriaVencimiento}/captura-vencimiento/eliminar`),
        restaurarCapturaVencimiento: (idCapturaAuditoriaVencimiento) =>
            axios.post(`/api/captura/${idAuditoria}/${idCapturaAuditoriaVencimiento}/captura-vencimiento/restaurar`),
        setEliminarCaptura: (estado) =>
            axios.post(`/api/captura/${idAuditoria}/eliminar/${estado}`),
        eliminarCapturasDefinitvo: (estado) =>
            axios.post(`/api/captura/${idAuditoria}/eliminar-todo`),
        setRestaurarCaptura: (estado) =>
            axios.post(`/api/captura/${idAuditoria}/restaurar/${estado}`),
        publicarAuditoriaVencimiento: () =>
            axios.post(`/api/captura/${idAuditoria}/publicar-vencimiento`),
        publicarAuditoriaIrd: () =>
            axios.post(`/api/captura/${idAuditoria}/publicar-ird`),
        publicarAuditoriaNoEncontrados: () =>
            axios.post(`/api/captura/${idAuditoria}/publicar-no-encontrados`),
        subirNuevaImagen: (idCapturAuditoriaVencimiento, data) =>
            axios.post(`/api/captura/${idCapturAuditoriaVencimiento}/subir-imagen`, data),
        actualizarNoEncontrado: (idCapturaNoEncontrado, capturaNoEncontrado) =>
            axios.post(`/api/captura/${idCapturaNoEncontrado}/no-encontrado`, capturaNoEncontrado),
        eliminarCapturaNoEncontrado: (idNoEncontrado) =>
            axios.post(`/api/captura/${idNoEncontrado}/no-encontrado/eliminar`),
        informarResultado: () =>
            axios.post(`/api/auditoria/${idAuditoria}/informar-resultados`),
        cambiarImagen: (imagen) =>
            axios.post(`/api/auditoria/${idAuditoria}/cambiar-imagen-acta`, imagen),
    }),
    fondos: () => ({
        getLideres: () =>
            axios.get(`/api/lideres`),
        getLideresInventarios: (fechaInicio, fechaFin) =>
            axios.get(`/api/lideres/inventario?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        getInventariosLider: (idLider, fechaInicio, fechaFin) =>
            axios.get(`/api/rendiciones/${idLider}/inventarios?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        guardaFondoGeneral: (idRendicion, idLider, numero_semana, datos, totales) =>
            axios.post(`/api/rendiciones/${idRendicion}/fondo/guardar/todos/lider/${idLider}/semana/${numero_semana}`, { fondos: datos, totales }),
        guardaFondo: (idRendicion, idLider, numero_semana, datos, totales) =>
            axios.post(`/api/rendiciones/${idRendicion}/fondo/guardar/lider/${idLider}/semana/${numero_semana}`, { fondo: datos, totales }),
        guardarPasaje: (idRendicion, dia, data) =>
            axios.post(`/api/rendiciones/${idRendicion}/fondo/nuevo/comprobante/pasaje/${dia}`, data),
        guardaDatosPasaje: (idRendicion, idBoletoPasaje, datos) =>
            axios.post(`/api/rendiciones/${idRendicion}/fondo/comprobante/pasaje/${idBoletoPasaje}`, datos),
        publicarFondos: (idRendicion, numero_comprobante, total) =>
            axios.post(`/api/rendiciones/${idRendicion}/comprobante/${numero_comprobante}/monto/${total}`),
        cerrarFondo: (idRendicion) =>
            axios.post(`/api/fondo/${idRendicion}/cerrar`),
        misFondos: (fechaInicio, fechaFin) =>
            axios.get(`/api/rendiciones/mis/fondos?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        comprobantesDeposito: (idRendicion) =>
            axios.get(`/api/rendiciones/${idRendicion}/comprobantes`),
        confirmarPasaje: (idBoletoPasaje) =>
            axios.get(`/api/rendiciones/fondo/boleto/${idBoletoPasaje}/confirmar/recepcion`),
        nuevoDetalleLider: (idLiderDetalle, datos) =>
            axios.post(`/api/lider/detalle/${idLiderDetalle}`, datos),
        guardaDestinos: (idComunaDistancia, idComunaOrigen, idComunaDestino, valor) =>
            axios.post(`/api/comunas/guarda/destino?idComunaDistancia=${idComunaDistancia}&idComunaOrigen=${idComunaOrigen}&idComunaDestino=${idComunaDestino}&valor=${valor}`),
        getCiudadesInventarios: (fechaInicio, fechaFin) =>
            axios.get(`/api/ciudades/inventario?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`),
        guardarDetalleHospedaje: (idRendicion, fondos, datos) =>
            axios.post(`/api/rendiciones/${idRendicion}/fondo/detalle/hospedaje`, { fondos, datos })
    }),
    rendiciones: () => ({
        misRendiciones: () =>
            axios.get(`/api/mis/rendiciones`),
        detalleRendicion: (idRendicion) =>
            axios.get(`/api/detalle/rendicion?idRendicion=${idRendicion}`),
        getRendiciones: (idLeader, numberWeek) =>
            axios.get(`/api/rendiciones?idLeader=${idLeader}&numberWeek=${numberWeek}`)
    }),
    gastos: () => ({
        nuevoGasto: (idRendicion, datos) =>
            axios.post(`/api/rendicion/${idRendicion}/new/gasto`, datos),
        getGasto: (idGasto) =>
            axios.get(`/api/rendicion/gasto/${idGasto}`),
        modificarGasto: (idGasto, gasto) =>
            axios.post(`/api/rendicion/gasto/${idGasto}/modificar`, gasto),
        subirFotoGasto: (foto) =>
            axios.post(`/api/subir/foto/gasto`, foto),
        getTipoDocumentos: () =>
            axios.get(`/api/tipo/documentos`),
        getTipoGastos: () =>
            axios.get(`/api/tipo/gastos`),
        rechazarGasto: (idGasto) =>
            axios.post(`/api/gasto/${idGasto}/rechazar`),
        aprobarGasto: (idGasto) =>
            axios.post(`/api/gasto/${idGasto}/aprobar`)
    }),
    hospedajes: () => ({
        getHospedajes: () =>
            axios.get(`/api/hospedajes`),
        nuevoHospedaje: (datos) =>
            axios.post(`/api/hospedajes/nuevo`, datos),
        getBuscarHospedajes: (idComuna) =>
            axios.get(`/api/hospedajes/buscar/${idComuna}`)
    }),

    comentarios: {
        saveComentario: (id, datos) => {
            return axios.post(`/api/comentarios/${id}/save`, datos)
        },
        getComentarios: (idInventario) => {
            return axios.get(`/api/comentarios/${idInventario}`)
        },
        editComentario: (id, comentario) => {
            return axios.post(`/api/comentarios/${id}/edit`, comentario)
        }
    },

    comentariosCliente: {
        saveComentario: (id, datos) => {
            return axios.post(`/api/comentariosCliente/${id}/save`, datos)
        },
        getComentarios: (idLocal) => {
            return axios.get(`/api/comentariosCliente/${idLocal}`)
        },
        editComentario: (id, comentario) => {
            return axios.post(`/api/comentariosCliente/${id}/edit`, comentario)
        },
        validarComentario: (id) => {
            return axios.post(`/api/comentariosCliente/${id}/validar`)
        },
    },

    logistica: {
        getLogistica: (idLocal) => {
            return axios.get(`/api/logistica/${idLocal}`)
        },
        editLogistica: (id, logistica) => {
            return axios.post(`/api/logistica/${id}/edit`, logistica)
        },
        saveLogistica: (id, datos) => {
            return axios.post(`/api/logistica/${id}/save`, datos)
        },
        deleteLogistica: (id) => {
            return axios.delete(`/api/logistica/${id}/delete`)
        }
    },

    comentarios_inv :{
        getComentarios: (idInventario) => {
            return axios.get(`/api/inventario-comentario/${idInventario}`)
        },
        saveComentario: (idInventario, datos) => {
            return axios.post(`/api/inventario-comentario/${idInventario}`, datos)
        },
    },

    reportes: {
        getReporte: (idInventario) => {
            return axios.get(`/api/reporte/${idInventario}`)
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/apiClient/v1.js